import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=0ef869d4&scoped=true"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js"
import style0 from "./DesktopNavigation.vue?vue&type=style&index=0&id=0ef869d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef869d4",
  null
  
)

export default component.exports